import FormattedMessage from 'I18n/components/FormattedMessage';
import { getDurationForContentList } from '../../utils/ContentUtils';
import { getHumanizedDuration } from '../../utils/utils';
import styled from 'academy-common-lib/utils/Styling';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Duration = styled.span.withConfig({
  displayName: "LessonDuration__Duration",
  componentId: "r19svk-0"
})(["font-weight:500;"]);
const count = (arr, predicate) => arr.filter(predicate).length;
const LessonDuration = ({
  contentList
}) => {
  const totalDurationInSeconds = getDurationForContentList(contentList);
  const totalDurationFormatted = getHumanizedDuration(totalDurationInSeconds);
  const list = contentList.toJS();
  const videos = count(list, content => content.contentType === 'VIDEO');
  const chapters = count(list, content => content.contentType === 'CHAPTER');
  return /*#__PURE__*/_jsxs(Duration, {
    children: [videos > 0 && /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.video",
        options: {
          count: videos
        }
      }), ' | ']
    }), chapters > 0 && /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "learningCenter.chapter",
        options: {
          count: chapters
        }
      }), ' | ']
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.lessonNavigator.info",
      options: {
        totalDuration: totalDurationFormatted
      }
    })]
  });
};
export default LessonDuration;